"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpreadMapFunc = exports.GuidCompareFunc = void 0;
exports.syncArray = syncArray;
const GuidCompareFunc = (destItem, sourceItem) => destItem.Guid === sourceItem.Guid;
exports.GuidCompareFunc = GuidCompareFunc;
const SpreadMapFunc = (sourceItem) => (Object.assign({}, sourceItem));
exports.SpreadMapFunc = SpreadMapFunc;
/**
 * Synchronizuje tablice, usuwając elementy, które nie istnieją w sourceValues i dodając nowe elementy
 * @param destValues docelowa tablica
 * @param sourceValues źródłowa tablica
 * @param findFunc funkcja, która sprawdza czy elementy są takie same (domyslnie porównuje pola Guid)
 * @param mapFunc funkcja, która mapuje elementy z sourceValues na destValues (domyslnie kopiowanie obiektu)
 * @returns true jeśli tablica została zmieniona
 */
function syncArray(destValues, sourceValues, findFunc = exports.GuidCompareFunc, mapFunc = exports.SpreadMapFunc) {
    if (!destValues || !sourceValues)
        return false;
    if (sourceValues.length === 0) {
        if (destValues.length > 0) {
            destValues.splice(0, destValues.length);
            return true;
        }
        else {
            return false;
        }
    }
    if (destValues.length === 0) {
        for (const sourceValue of sourceValues) {
            destValues.push(mapFunc(sourceValue));
        }
        return true;
    }
    const orgLength = destValues.length;
    //jeśli tablice są równe to nie ma sensu ich porównywac
    if (orgLength === sourceValues.length &&
        sourceValues.every((sourceValue) => destValues.some((destValue) => findFunc(destValue, sourceValue)))) {
        return false;
    }
    let changed = false;
    //dodaje nowe elementy
    for (const sourceValue of sourceValues) {
        if (destValues.some((destValue) => findFunc(destValue, sourceValue))) {
            continue;
        }
        destValues.push(mapFunc(sourceValue));
        changed = true;
    }
    //usuwam elementy, które nie istnieją w sourceValues
    for (let i = orgLength - 1; i >= 0; i--) {
        if (sourceValues.some((sourceValue) => findFunc(destValues[i], sourceValue))) {
            continue;
        }
        destValues.splice(i, 1);
        changed = true;
    }
    return changed;
}
//# sourceMappingURL=syncArray.js.map